import { Reducer } from 'redux'
import { TagsState } from '@models/tag'
import {TagsActionTypes} from '@actions/tag';




// Type-safe initialState!
export const initialState: TagsState = {
    data: [],
    errors: undefined,
    loading: false,
    count: 0
};

const reducer: Reducer<TagsState> = (state = initialState, action) => {
  switch (action.type) {
      case TagsActionTypes.FETCH_REQUEST: {
          return {
              ...state,
              loading: true
          }
      }

      case TagsActionTypes.FETCH_SUCCESS: {
          const{data, meta} = action.payload;
          return {
              ...state,
              loading: false,
              data,
              count: meta.total_count
          }
      }

      case TagsActionTypes.FETCH_ERROR: {
          return { ...state, loading: false, errors: action.payload.error }
      }

      case TagsActionTypes.DELETE_SUCCESS:{
          return{
              ...state,
              data : state.data.filter( tag => tag.id != action.payload.params.id),
              count: state.count - 1
          }
      }

      case TagsActionTypes.CREATE_SUCCESS:{
          const tag = action.payload;
          return{
              ...state,
              data : [tag, ...state.data],
              count: state.count + 1
          }
      }

      case TagsActionTypes.UPDATE_SUCCESS:{
          const tag = action.payload;
          return{
              ...state,
              data : state.data.map( item => (item.id == tag.id) ? {
                  ...item,
                  ...tag
              } : item ),
          }
      }

    default: {
      return state
    }
  }
};

export { reducer as tagReducer }
